import { createFileRoute } from '@tanstack/react-router'
import { WorkLocationsSection } from '../../../features/org-units/work-locations-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/work-locations')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'work-locations'),
  component: WorkLocationsSection,
})
